export const API_URL = import.meta.env.VITE_API_URL
export const BOLT_BACKEND_URL = import.meta.env.VITE_BOLT_BACKEND_URL ?? ''
export const IS_PROD = import.meta.env.VERCEL_ENV === 'production' || import.meta.env.VITE_VERCEL_ENV === 'production'

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN

// Environment checks
export const IS_PRODUCTION = import.meta.env.VERCEL_ENV === 'production'
